export default function alertUnhandledError(eventId: string): void {
  alert(
    `An unexpected error has occurred. Our technical team has been notified.\n\nIf you require assistance, please contact our support team with the reference:\n${eventId}`,
  );
}
